import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c0c6e96&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c0c6e96&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c6e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0c6e96')) {
      api.createRecord('0c0c6e96', component.options)
    } else {
      api.reload('0c0c6e96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c0c6e96&scoped=true&lang=pug", function () {
      api.rerender('0c0c6e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-input-price/index.vue"
export default component.exports